import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8233a888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-top-tips-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "选择商品", -1))
const _hoisted_3 = { class: "goods-info-box" }
const _hoisted_4 = { class: "goods-image-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "goods-name-box" }
const _hoisted_7 = {
  key: 0,
  class: "goods-sku-box"
}
const _hoisted_8 = {
  key: 0,
  class: "green"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "inner-card-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner-card-left" }, "配送信息", -1))
const _hoisted_12 = { class: "inner-card-right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "配送方式：快递", -1))
const _hoisted_14 = { class: "inner-card-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner-card-left" }, "发货方式", -1))
const _hoisted_16 = { class: "inner-card-right" }
const _hoisted_17 = {
  key: 0,
  class: "express-info-box"
}
const _hoisted_18 = { class: "express-row-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "物流公司：", -1))
const _hoisted_20 = { class: "express-row-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "物流单号：", -1))
const _hoisted_22 = { class: "align-right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_dialog_container = _resolveComponent("ui-dialog-container")!

  return (_openBlock(), _createBlock(_component_ui_dialog_container, null, {
    header: _withCtx(() => [
      _createVNode(_component_ui_dialog_title, {
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reject'))),
        title: "订单发货"
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ui_form, {
        style: {"padding":"20px"},
        model: _ctx.ruleForm,
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode("待发货 " + _toDisplayString(_ctx.goodsInfo.waitSend) + "已发货 " + _toDisplayString(_ctx.goodsInfo.send), 1)
          ]),
          _createVNode(_component_ui_table, {
            data: _ctx.orderInfo.orderGoods,
            style: {"margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, null, {
                header: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    class: "name-check-box",
                    modelValue: _ctx.checkAll,
                    indeterminate: _ctx.checkIndeter,
                    onInput: _ctx.checkAllGoods
                  }, null, 8, ["modelValue", "indeterminate", "onInput"]),
                  _createTextVNode(" 商品 ")
                ]),
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_checkbox, {
                      disabled: row.packId,
                      class: "goods-check-box",
                      modelValue: !!_ctx.checkList[row.id],
                      onInput: ($event: any) => (_ctx.changeGoods(row.id))
                    }, null, 8, ["disabled", "modelValue", "onInput"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: row.goodsDetails.cover
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(row.goodsDetails.name), 1),
                      (row.goodsDetails.skuName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row.goodsDetails.skuName), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "num",
                width: "120",
                label: "数量"
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  (row.packId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "已发货"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, "待发货"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "运单号",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode("-")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", null, "收货人：" + _toDisplayString(_ctx.orderInfo.username) + " " + _toDisplayString(_ctx.orderInfo.mobile), 1),
              _createElementVNode("div", null, " 收货地址：" + _toDisplayString(_ctx.orderInfo.province) + " " + _toDisplayString(_ctx.orderInfo.city) + " " + _toDisplayString(_ctx.orderInfo.county) + " " + _toDisplayString(_ctx.orderInfo.address), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.ruleForm.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.type) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        label: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.ruleForm.type == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_select, {
                        class: "select-box",
                        modelValue: _ctx.ruleForm.expressId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.expressId) = $event)),
                        filterable: "",
                        placeholder: "请选择物流公司"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressList.list, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.expressBill,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.expressBill) = $event)),
                        placeholder: "请输入物流单号"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_ui_form_item, { style: {"margin":"0"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.submitForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("发货")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}